export enum AssessmentOutcomeRefKey {
  DEVICE_OBSERVATION_ID = 'DEVICE_OBSERVATION_ID',
  PREVIOUS_DEVICE_OBSERVATION_ID = 'PREVIOUS_DEVICE_OBSERVATION_ID',
  QUESTIONNAIRE_RESPONSE_ID = 'QUESTIONNAIRE_RESPONSE_ID',
  SPIROMETRY_REVERSIBILITY_STATE = 'SPIROMETRY_REVERSIBILITY_STATE',
  SPIROMETRY_REVERSIBILITY_DIFF_VALUE = 'SPIROMETRY_REVERSIBILITY_DIFF_VALUE',
  SPIROMETRY_REVERSIBILITY_PERC_VALUE = 'SPIROMETRY_REVERSIBILITY_PERC_VALUE',
  SPIROMETRY_REVERSIBILITY_PRE_VALUE = 'SPIROMETRY_REVERSIBILITY_PRE_VALUE',
  SPIROMETRY_REVERSIBILITY_POST_VALUE = 'SPIROMETRY_REVERSIBILITY_POST_VALUE',
  SPIROMETRY_REVERSIBILITY_OUTCOME_ID = 'SPIROMETRY_REVERSIBILITY_OUTCOME_ID',
}
